import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import WhitePaperIndexPage from 'buyside/components/presentation/WhitePaper/IndexPage/WhitePaperIndexPage';

import { whitePaperIndexUrl } from 'buyside/util/urlHelper';

const WhitePaperIndexPageRoot: FC = () => {
  return (
    <Router basename={whitePaperIndexUrl()}>
      <WhitePaperIndexPage />
    </Router>
  );
};

export default WhitePaperIndexPageRoot;
